import React, { useEffect, useState, useRef } from "react";

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import '../Home3/swiper.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import { EffectFade, Navigation, Pagination, Autoplay, EffectCoverflow, EffectCreative } from 'swiper/modules';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Button from "../Button/Button";
import PriceDisplay from "../PriceDisplay";
import { Circle, Facebook, Linkedin, Phone, Twitter } from "react-feather";
import Second from '../../assets/images/home/thirdSection/2.jpg';
import Banner from '../../assets/images/blog/user-img-1.jpg';
import tables from '../../assets/images/blog/tables.jpg';
import img3 from '../../assets/images/blog/blog-titleimg.jpg';
import ImageReactangle from '../Contact/ImageReactangle';
import Image from '../Contact/Image';
import Footer from "../footer";
import brand from "../../brandConfig";
import B1 from "../../assets/images/banner/b1.jpg";
import B2 from "../../assets/images/banner/b2.jpg";
import B3 from "../../assets/images/banner/b5.webp";
import B4 from "../../assets/images/banner/b6.webp";
import planDep from "../../assets/images/banner/planeDep.svg";
import planAri from "../../assets/images/banner/planeAri.svg";
import HeadingSep from "../../assets/images/banner/heading-sep.png";
import Bed from "../../assets/images/Detail/bed-svgrepo-com.png";
import Plane from "../../assets/images/Detail/plane-svgrepo-com.png";
import Cart from "../../assets/images/Detail/car-50.png";

import service, { getImageUrl } from "../../Service/Service";
import Navbar from "../navbar";
import CustomizeSection from "../Home3/CustomizeSection";
import InputSection from "./InputSectionUmrah";
import parse from 'html-react-parser';

const PackageDetail = props => {
  const [hotels, setHotels] = useState([])
  const [makkahhotels, setMakkahHotels] = useState()
  const [madinahhotels, setMadinahHotels] = useState()
  const [imagesAll, setImagesAll] = useState([])
  const [imagesMak, setImagesMak] = useState([])
  const [imagesMad, setImagesMad] = useState([])

  const [rating, setRating] = useState(3)

  const [packages, setPackage] = useState()
  const [paras, setParas] = useState([]);
  const [pkgtype, setPkgType] = useState('holiday');

  const getHotels = () => {
    if (!packages || !packages.uid) {
      console.log('getHotels: packages or uid missing', packages);
      return;
    }
    
    console.log('=== GETTING HOTELS ===');
    console.log('Package object:', packages);
    
    service.getAllhotel().then(response => {
      let h = response.data || [];
      
      // Debug: Log the raw response to see what we're getting
      console.log('=== RAW HOTEL API RESPONSE ===');
      console.log('Total hotels:', h.length);
      console.log('Full response data:', response.data);
      if (h.length > 0) {
        console.log('First hotel (full object):', JSON.stringify(h[0], null, 2));
        console.log('First hotel keys:', Object.keys(h[0]));
        console.log('First hotel img1 value:', h[0].img1);
        console.log('First hotel img1 type:', typeof h[0].img1);
        console.log('First hotel img1 === null:', h[0].img1 === null);
        console.log('First hotel img1 === undefined:', h[0].img1 === undefined);
        console.log('First hotel all img fields:', {
          img1: h[0].img1,
          img2: h[0].img2,
          img3: h[0].img3,
          img4: h[0].img4,
          img5: h[0].img5,
          img6: h[0].img6,
          img7: h[0].img7,
          img8: h[0].img8,
          img9: h[0].img9,
          img10: h[0].img10,
        });
        // Check all hotels
        h.forEach((hotel, index) => {
          console.log(`Hotel ${index + 1} (ID: ${hotel.uid}, Name: ${hotel.name}):`, {
            img1: hotel.img1,
            img2: hotel.img2,
            img3: hotel.img3,
            img4: hotel.img4,
            img5: hotel.img5,
          });
        });
      }
      
      // Use == for loose comparison to handle string/number mismatch
      let makkah = packages.makkah_hotel ? h.find(x => x.uid == packages.makkah_hotel || x.uid == parseInt(packages.makkah_hotel)) : null;
      let madinah = packages.madina_hotel ? h.find(x => x.uid == packages.madina_hotel || x.uid == parseInt(packages.madina_hotel)) : null;
      
      // Debug: Log all hotels to see which ones have images
      console.log('=== ALL HOTELS DEBUG ===');
      h.forEach(hotel => {
        const imageCount = [1,2,3,4,5,6,7,8,9,10].filter(i => {
          const img = hotel[`img${i}`];
          return img && typeof img === 'string' && img.trim() !== '';
        }).length;
        if (imageCount > 0) {
          console.log(`✅ Hotel ${hotel.uid} (${hotel.name}): ${imageCount} images`);
        } else {
          console.log(`❌ Hotel ${hotel.uid} (${hotel.name}): 0 images`);
        }
      });
      
      console.log('Package hotel IDs - Makkah:', packages.makkah_hotel, 'Madina:', packages.madina_hotel);
      console.log('Found Makkah hotel:', makkah);
      console.log('Found Madina hotel:', madinah);
      let allImg = [];
      let makImg = [];
      let madImg = [];
      // Helper function to add images from hotel (img1-img10) and filter out null/empty
      const addHotelImages = (hotel, targetArray) => {
        if (hotel) {
          console.log('Processing hotel images for:', hotel.name);
          console.log('Hotel object keys:', Object.keys(hotel));
          console.log('Hotel image fields:', {
            img1: hotel.img1,
            img2: hotel.img2,
            img3: hotel.img3,
            img4: hotel.img4,
            img5: hotel.img5,
          });
          const initialLength = targetArray.length;
          for (let i = 1; i <= 10; i++) {
            const imgKey = `img${i}`;
            const imgValue = hotel[imgKey];
            // Check if image exists and is not null/undefined/empty
            if (imgValue && typeof imgValue === 'string' && imgValue.trim() !== '') {
              console.log(`✅ Adding image ${imgKey}:`, imgValue);
              targetArray.push(imgValue);
            } else {
              console.log(`❌ Image ${imgKey} is empty or invalid:`, imgValue);
            }
          }
          const added = targetArray.length - initialLength;
          console.log(`Added ${added} images from ${hotel.name} (total in array: ${targetArray.length})`);
        }
      };
      
      // First, try to use images from package object (populated by backend)
      console.log('=== TRYING TO USE IMAGES FROM PACKAGE OBJECT ===');
      console.log('Package type:', packages.package_type);
      console.log('All package keys:', Object.keys(packages));
      
      // Always try to get Makkah images
      for (let i = 1; i <= 10; i++) {
        const makkahKey = `makkah_img${i}`;
        const makkahImg = packages[makkahKey];
        if (makkahImg && typeof makkahImg === 'string' && makkahImg.trim() !== '') {
          console.log(`✅ Adding ${makkahKey}:`, makkahImg);
          allImg.push(makkahImg);
          makImg.push(makkahImg);
        }
      }
      
      // Try to get Madina images (check both 'Umrah' and 'umrah' for case sensitivity)
      const isUmrahPackage = packages.package_type && (packages.package_type.toLowerCase() === 'umrah' || packages.package_type === 'Umrah');
      console.log('Is Umrah package?', isUmrahPackage);
      
      if (isUmrahPackage || packages.madina_hotel) {
        for (let i = 1; i <= 10; i++) {
          const madinaKey = `madina_img${i}`;
          const madinaImg = packages[madinaKey];
          if (madinaImg && typeof madinaImg === 'string' && madinaImg.trim() !== '') {
            console.log(`✅ Adding ${madinaKey}:`, madinaImg);
            allImg.push(madinaImg);
            madImg.push(madinaImg);
          }
        }
      }
      
      // Always try to get images from hotels (they might have more images than package object)
      if (makkah) {
        console.log('Adding images from Makkah hotel...');
        addHotelImages(makkah, allImg);
        addHotelImages(makkah, makImg);
      }
      
      if (isUmrahPackage && madinah) {
        console.log('Adding images from Madina hotel...');
        addHotelImages(madinah, allImg);
        addHotelImages(madinah, madImg);
      }
      
      // Get images from ALL hotels that have images (not just assigned hotels)
      console.log('=== COLLECTING IMAGES FROM ALL HOTELS ===');
      console.log(`Total hotels in database: ${h.length}`);
      let hotelsWithImages = 0;
      h.forEach(hotel => {
        if (hotel && hotel.uid) {
          const hotelImages = [];
          for (let i = 1; i <= 10; i++) {
            const imgKey = `img${i}`;
            const imgValue = hotel[imgKey];
            if (imgValue && typeof imgValue === 'string' && imgValue.trim() !== '') {
              hotelImages.push(imgValue);
            }
          }
          if (hotelImages.length > 0) {
            hotelsWithImages++;
            console.log(`✅ Found ${hotelImages.length} images in hotel ${hotel.uid} (${hotel.name})`);
            allImg.push(...hotelImages);
            // If it's the makkah hotel, add to makImg
            if (hotel.uid == packages.makkah_hotel || hotel.uid == parseInt(packages.makkah_hotel)) {
              makImg.push(...hotelImages);
            }
            // If it's the madina hotel, add to madImg
            if (hotel.uid == packages.madina_hotel || hotel.uid == parseInt(packages.madina_hotel)) {
              madImg.push(...hotelImages);
            }
          } else {
            console.log(`❌ Hotel ${hotel.uid} (${hotel.name}) has no images`);
          }
        }
      });
      console.log(`Hotels with images: ${hotelsWithImages} out of ${h.length}`);
      
      // Remove duplicates
      allImg = [...new Set(allImg)];
      makImg = [...new Set(makImg)];
      madImg = [...new Set(madImg)];





      // Always get images from hotels (remove duplicate check above)
      // This is handled in the section above




      setMakkahHotels(makkah);
      setMadinahHotels(madinah);
      setHotels(h);

      console.log('=== FINAL IMAGE ARRAYS ===');
      console.log('allImg length:', allImg.length, 'contents:', allImg);
      console.log('makImg length:', makImg.length, 'contents:', makImg);
      console.log('madImg length:', madImg.length, 'contents:', madImg);
      
      if (allImg.length === 0) {
        console.warn('⚠️ WARNING: No images found! Check package object and hotels.');
      }
      
      setImagesAll(allImg);
      setImagesMak(makImg);
      setImagesMad(madImg);
      
      // Safely scroll to top section
      try {
        var scrollDiv = document.getElementById("topsec");
        if (scrollDiv) {
          window.scrollTo({ top: scrollDiv.offsetTop, behavior: 'smooth' });
        }
      } catch (e) {
        console.log('Scroll error:', e);
      }
    }).catch(error => {
      console.error('Error fetching hotels:', error);
    });
  }

  useEffect(() => {
    if (packages && packages.uid) {
      getHotels();
    }
  }, [packages])

  const getPackages = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let packId = params.get('package');
    let tt = params.get('type');
    service.getpackagebyidUmrah({ uid: packId }).then(response => {
      if (response.data && response.data[0]) {
        const packageData = response.data[0];
        console.log('=== PACKAGE DATA RECEIVED ===');
        console.log('Package:', packageData);
        console.log('Makkah images in package:', {
          makkah_img1: packageData.makkah_img1,
          makkah_img2: packageData.makkah_img2,
          makkah_img3: packageData.makkah_img3,
          makkah_img4: packageData.makkah_img4,
          makkah_img5: packageData.makkah_img5,
        });
        console.log('Madina images in package:', {
          madina_img1: packageData.madina_img1,
          madina_img2: packageData.madina_img2,
          madina_img3: packageData.madina_img3,
          madina_img4: packageData.madina_img4,
        });
        setPackage(packageData);
        if (packageData.category_name && packageData.category_name.includes('4')) {
          setRating(4);
        }
        else if (packageData.category_name && packageData.category_name.includes('5')) {
          setRating(5);
        }
      }
    }).catch(error => {
      console.error('Error fetching package:', error);
    })
  }

  const getAllparas = (ff) => {
    service.getAllparas().then((response) => {
      let dep = response.data.filter((x) => x.package_id == ff && x.para_type == 'UMRAH');
      setParas(dep)

    });
  };

  useEffect(() => {
    if (packages && packages.uid) {
      getAllparas(packages.uid)
      // if(packages.package_type=='Umrah'){
      //   getAllparas(-2)
      // }else{
      //   getAllparas(-1)
      // }
    }


  }, [packages])

  useEffect(() => {
    getPackages();
    AOS.init();

  }, [])

  if (!packages) {
    return (
      <div id="topsec">
        <Navbar bg={1} />
        <div className="pt-16 flex items-center justify-center min-h-screen">
          <span className="loading loading-ring loading-lg"></span>
        </div>
      </div>
    );
  }

  return (<div id="topsec">
    <Navbar bg={1} />
    <div className="pt-16">
      <div className="grid grid-cols-1 md:grid-cols-2 p-3 w-[95%] md:w-[90%] mx-auto" >
        {
          packages && imagesAll && imagesAll.length > 0 ? (
            <BackSwiper packages={packages} imagesAll={imagesAll} />
          ) : packages ? (
            <div className="w-full h-[50vh] md:h-[70vh] 2xl:h-[50vh] p-1 md:p-4 flex items-center justify-center bg-gray-100 rounded-lg">
              <div className="text-center">
                <p className="text-gray-500 mb-2">No images available</p>
                <p className="text-xs text-gray-400">Images: {imagesAll?.length || 0} | Hotels loaded: {hotels?.length || 0}</p>
                <p className="text-xs text-gray-400">Makkah Hotel ID: {packages.makkah_hotel || 'None'}</p>
                <p className="text-xs text-gray-400">Madina Hotel ID: {packages.madina_hotel || 'None'}</p>
              </div>
            </div>
          ) : null
        }
        {
          packages && 
          <DetailSection packages={packages} rating={rating} />
        }

      </div>

      {/* <div className="grid grid-cols-1 md:grid-cols-2  p-10 bg-primary">
    <p className='col-span-full tracking-[1px] text-3xl font-[700] leading-12 my-3 px-1 py-4 text-center'>Accomodation Features</p>
      {
        makkahhotels && imagesMak && imagesMak.length>0 && 
        <DescriptionSection hotel={makkahhotels} rating={rating} text={`Hotel in ${packages.makkah_hotel_city}`}/>
      }
      {
        makkahhotels && imagesMak && imagesMak.length>0 && 
        <BackSwiper packages={packages} imagesAll={imagesMak}/>
        
      }
        
    </div> */}

      {/* <div className="grid grid-cols-1 md:grid-cols-2  px-10 py-5">
    {
        madinahhotels && imagesMad && imagesMad.length>0 && 
        <BackSwiper packages={packages} imagesAll={imagesMad}/>
        
      }
      {
        madinahhotels && imagesMad && imagesMad.length>0 && 
        <DescriptionSection hotel={madinahhotels} rating={rating} text={`Hotel in ${packages.madinah_hotel_city}`}/>
      }
      
        
    </div> */}

      <div className="mt-[30px] mb-[60px] w-[90%] md:w-[80%] mx-auto grid grid-cols-1">
        {/* Display package description if it exists */}
        {packages && packages.description && (
          <div className="mb-6">
            {parse(packages.description)}
          </div>
        )}
        {/* Display additional paragraphs from paras API */}
        {paras.map((x, index) => {
          return <div key={index}>{parse(x.description)}</div>
        })}
      </div>

      {/* <CustomizeSection/> */}
      <Footer />
    </div>
  </div>
  )
}


const BackSwiper = ({ imagesAll }) => {
  const swiperRef = useRef(null);
  
  // Filter out null, undefined, or empty string images
  const validImages = imagesAll.filter(img => img && img.trim() !== '');
  
  if (validImages.length === 0) {
    return (
      <div className="w-full h-[50vh] md:h-[70vh] 2xl:h-[50vh] p-1 md:p-4 flex items-center justify-center bg-gray-100 rounded-lg">
        <p className="text-gray-500">No images available</p>
      </div>
    );
  }
  
  return (
    <div className="w-full h-[50vh] md:h-[70vh] 2xl:h-[50vh] p-1 md:p-4 relative group">
      <style>{`
        .package-swiper-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 20;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.4);
          color: rgba(255, 255, 255, 0.9);
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: bold;
          transition: all 0.3s ease;
          opacity: 0.8;
        }
        .package-swiper-nav-btn:hover {
          background: rgba(0, 0, 0, 0.6);
          color: rgba(255, 255, 255, 1);
          opacity: 1;
        }
        .package-swiper-nav-btn:active {
          transform: translateY(-50%) scale(0.95);
        }
        .package-swiper-nav-prev {
          left: 15px;
        }
        .package-swiper-nav-next {
          right: 15px;
        }
        .package-swiper-nav-btn:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
      `}</style>
      <button
        className="package-swiper-nav-btn package-swiper-nav-prev"
        onClick={() => swiperRef.current?.slidePrev()}
        aria-label="Previous image"
      >
        ‹
      </button>
      <button
        className="package-swiper-nav-btn package-swiper-nav-next"
        onClick={() => swiperRef.current?.slideNext()}
        aria-label="Next image"
      >
        ›
      </button>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        spaceBetween={30}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="mySwiper package-swiper"
      >
        {
          validImages.map((x, index) => {
            return <SwiperSlide key={index}>
              <img src={getImageUrl(x)} className="object-cover h-full w-full rounded-lg" alt={`Image ${index + 1}`} />
            </SwiperSlide>
          })
        }

      </Swiper>

    </div>
  )
}

const DetailSection = ({ packages, rating }) => {
  const [showtoast, setShowToast] = useState(false);
  return (
    <div className="w-full p-4">
      <p className='tracking-[2px] text-xl md:text-3xl font-[700] leading-6 mt-1 px-1 py-2 '>{packages.name}</p>
      <p className='tracking-[1px] text-md mb-2  leading-6 mt-1 px-1 py-2 '>{packages.package_type == 'Umrah' ? `Perform Umrah with Best Price` : `Holidays with Best Price`}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

        {packages.package_type == 'Umrah' ?
          <div className="p-2 bg-primary">
            <p className='tracking-[1px] text-md font-[500]  leading-6 px-1 py-1 '>{packages.makkah_hotel_city} Hotel Nights ({packages.makkah_nights})</p>
            <p className='tracking-[1px] text-xl font-[500]  leading-7 px-1  '>{packages.makkah_hotel_name}</p>
          </div> :
          <div className="p-2 bg-primary">
            <p className='tracking-[1px] text-md font-[500]  leading-6 px-1 py-1 '>{packages.makkah_hotel_city} </p>
            <p className='tracking-[1px] text-xl font-[500]  leading-7 px-1  '>{packages.makkah_hotel_name}</p>
          </div>}




        {packages.package_type == 'Umrah' ? <div className="p-2 bg-primary">
          <p className='tracking-[1px] text-md font-[500]  leading-6 px-1 py-1 '>{packages.madinah_hotel_city} Hotel Nights ({packages.madina_nights})</p>
          <p className='tracking-[1px] text-xl font-[500]  leading-7 px-1  '>{packages.madinah_hotel_name}</p>
        </div> : <div></div>}
      </div>
      <hr className="mt-3" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-1">
        <div className="flex p-2 items-center ">
          <img src={Plane} className="h-[50px] w-[50px] rounded-full bg-secondary p-2 flex justify-center " />
          <p className='tracking-[1px] text-lg font-[400]  leading-7 px-1  '>Flight</p>
        </div>

        <div className="flex p-2 items-center ">
          <img src={Bed} className="h-[50px] w-[50px] rounded-full bg-secondary p-2 flex justify-center " />
          <p className='tracking-[1px] text-lg font-[400]  leading-7 px-1  '>{packages.package_type == 'Umrah' ? packages.makkah_hotel_city : ''} Hotel</p>
        </div>

        {packages.package_type == 'Umrah' ? <div className="flex p-2 items-center ">
          <img src={Bed} className="h-[50px] w-[50px] rounded-full bg-secondary p-2 flex justify-center " />
          <p className='tracking-[1px] text-lg font-[400]  leading-7 px-1  '>{packages.madinah_hotel_city} Hotel</p>
        </div> : ''}
        {packages.package_type != 'Umrah' ? <div className="flex p-2 items-center ">
          <img src={Cart} className="h-[50px] w-[50px] rounded-full bg-secondary p-2 flex justify-center " />
          <p className='tracking-[1px] text-lg font-[400]  leading-7 px-1  '>Airport Pick Up</p>
        </div> : ''}

      </div>

      <hr />



      <div className="rating flex justify-start p-1 my-2">
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked={rating == 4 || rating == 5} />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked={rating == 5} />
      </div>
      <p className='tracking-[2px] text-4xl font-[800] leading-6 mt-1 px-1 py-2 '>Price: <PriceDisplay amount={packages.price} displayCurrency="GBP" /></p>
      <div className="flex my-2">
        <button className="btn border-secondary bg-[transparent]  self-center mx-2 hover:bg-secondary hover:text-white" onClick={() => {
          if (packages.package_type == 'Umrah')
            window.location.href = 'tel:02081949506'
          else
            window.location.href = 'tel:02081949506'
        }}><Phone className="" /> {packages.package_type == 'Umrah' ? `02081949506` : `02081949506`}</button>
        <button className="btn border-secondary bg-[transparent]  self-center hover:bg-secondary hover:text-white" onClick={() => document.getElementById('my_modal_3').showModal()}><Circle /> Book Now</button>
      </div>
      <dialog id="my_modal_3" className="modal">
        <div className="modal-box w-11/12 max-w-5xl bg-secondary">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 text-white">✕</button>
          </form>
          <InputSection setShowToast={setShowToast} selectedPackage={packages} modal={true} />
        </div>
      </dialog>

    </div>
  )
}

const DescriptionSection = ({ hotel, rating, text }) => {
  console.log(hotel);
  return (
    <div className="w-full p-4">
      <p className='tracking-[2px] text-xl md:text-4xl font-[700] leading-6 mt-1 px-1 py-2 '>{hotel.name}</p>
      <p className='tracking-[2px] text-lg md:text-lg font-[400] leading-6 mt-1 px-1 py-2 '>{text}</p>

      <div className="rating flex justify-start p-1 my-2">
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked={rating == 4 || rating == 5} />
        <input type="radio" name={`rating-11`} className="mask mask-star-2 bg-secondary" checked={rating == 5} />
      </div>

      <p className='tracking-[1px] text-lg font-[400] leading-6 mt-1 px-1 py-2 '>{hotel.description}</p>
      <p className='tracking-[1px] text-lg font-[400] leading-6 mt-1 px-1 py-2 '>{hotel.description2}</p>

    </div>
  )
}




export default PackageDetail